export const fire = {
  fireQuoteSelectedPlan: (state) => {
    if (state.quotation.fireForm.planNo && state.quotation.fireParam.plans.plans && state.quotation.fireParam.plans.plans.length > 0) {
      const selectedPlan = state.quotation.fireParam.plans.plans.find(x => x.planNo === state.quotation.fireForm.planNo)
      if (selectedPlan) {
        return selectedPlan
      }
    }
    return null
  }
}
